import { IPermissionKey, PermissionFormat } from './interfaces';

/**
 * Parses a string permission into a general permissions object containing keyed action and subject.
 *
 * Supports old underscore-split formats (both core and support) and new colon-split format.
 *
 * For single word string permissions assumes, that the word is an action (e.g. 'impersonate').
 *
 * @param permission - permission to parse
 * @param format - format to use for parsing when it is ambiguous. By default uses Core format.
 * @returns parsed permission
 */
export const parsePermission = (
  permission: string,
  format: PermissionFormat = PermissionFormat.Core
): IPermissionKey => {
  if (permission.indexOf(':') !== -1) {
    const split = permission.split(':');

    return {
      action: split[1],
      subject: split[0],
    };
  }

  const split = permission.split('_');

  // if unable to split assume word is action (e.g. impersonate)
  if (split.length === 1) {
    return {
      action: split[0],
      subject: 'default',
    };
  }

  if (format === PermissionFormat.Core) {
    const [action, ...subject] = split;

    return {
      action,
      subject: subject.join('_'),
    };
  }

  if (format === PermissionFormat.Support) {
    return {
      action: split[split.length - 1],
      subject: split.slice(0, split.length - 1).join('_'),
    };
  }

  throw Error('Unknown permission format, should never happen.');
};
